import dp from './../shoaib-khalid.jpeg';

const Header = () => {
    return (
        <header className='mb-4 bg-body-tertiary rounded-3'>
            <div className='d-flex-inline'>
                <img src={dp} className="display-picture rounded-circle float-start" alt="shoaib khalid display picture" />
                
                <div className='text-start'>
                    <p className='display-6 d-print-inline-block ml-2 pt-4 mb-1'>
                        I am Shoaib Khalid
                    </p>
                    <blockquote className='blockquote'>
                        <p>
                        Data Science Graduate from <a href="https://www.concordiabootcamps.ca/data-science">Concordia Bootcamps </a>   
                        </p>
                    </blockquote>
                </div>
            </div>

           

            
        </header>
    )
}

export default Header;